/* __next_internal_client_entry_do_not_use__ RenderPOSRouterExcludingOrderManagerAndOnboarding auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SignInAndRedirect } from "@faire/retailer-visitor-shared/components/SignInAndRedirect";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { Route } from "@faire/web-api--source/Route";
import { props as pointOfSaleRouteProps } from "@faire/web-api--source/routes/point-of-sale";
import { props as posAboutRouteProps } from "@faire/web-api--source/routes/point-of-sale/about";
import { props as posConsentRouteProps } from "@faire/web-api--source/routes/point-of-sale/consent";
import React from "react";
import { LazyPosConsent } from "@faire/retailer/components/PosConsent";
import { LazyPOSAbout } from "@faire/retailer/views/point-of-sale/landing-page/LazyPOSAbout";
import { POSRouter } from "@faire/retailer/views/point-of-sale/POSRouter";
export var RenderPOSRouterExcludingOrderManagerAndOnboarding = function() {
    return /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, pointOfSaleRouteProps), {
        component: Router
    }));
};
var Router = function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    return /*#__PURE__*/ _jsxs(Switch, {
        children: [
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posConsentRouteProps), {
                component: LazyPosConsent
            })),
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posAboutRouteProps), {
                component: LazyPOSAbout
            })),
            isLoggedInRetailer ? /*#__PURE__*/ _jsx(POSRouter, {}) : /*#__PURE__*/ _jsx(SignInAndRedirect, {})
        ]
    });
};
